export const twitterAccountData = [
  {
    post: "#78bdashf75421",
    activity: "1.2k",
    activity_id: 5,
  },
  {
    post: "#ogegqwb78521",
    activity: "1.1k",
    activity_id: 7,
  },
  {
    post: "#jhdfejrh78988",
    activity: "2.3k",
    activity_id: 1,
  },
  {
    post: "#w75485hjjdw",
    activity: "3.1k",
    activity_id: 8,
  },
  {
    post: "#j715ewhrah524",
    activity: "1.3k",
    activity_id: 2,
  },
  {
    post: "#mo467pei4845",
    activity: "1.7k",
    activity_id: 3,
  },
  {
    post: "#ew845588fje",
    activity: "1.5k",
    activity_id: 5,
  },
  {
    post: "#fw874dfhu156",
    activity: "1.4k",
    activity_id: 9,
  },
];
